/** @jsx jsx */
import React from 'react';
import { components } from '@atlaskit/select';
import { css, jsx } from '@emotion/react';
const getFooterStyle = () => {
  return css({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
  });
};
export class Menu extends React.Component {
  render() {
    return jsx(components.Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && jsx("div", {
      css: getFooterStyle()
    }, this.props.selectProps.footer));
  }
}